import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-brand-gray px-4 py-4 sm:px-6 sm:py-5" aria-labelledby="guarantee-heading" data-id="element-70" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl rounded-xl border border-brand-green/40 bg-white p-3 text-center shadow-sm sm:p-4" data-id="element-71" data-mp="222darht32om9">
        <div className="mx-auto mb-1.5 flex h-10 w-10 items-center justify-center rounded-full bg-brand-green/15" data-id="element-72" data-mp="1x4uxxgby3p8z">
          <ShieldCheckIcon className="h-5 w-5 text-brand-navy" aria-hidden="true" data-id="element-73" data-mp="19co8z28jukjl" />
        </div>
        <h2 id="guarantee-heading" className="mb-0.5 text-[17px] font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-74" data-mp="14dl1lb53k28g">
          Il Tuo Acquisto è Protetto al 100%
        </h2>
        <p className="mb-1 font-heading text-[12px] font-extrabold text-brand-green sm:text-sm" data-id="element-75" data-mp="qo9j4i9yxckd">
          🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
        </p>
        <p className="text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-76" data-mp="lowkl09qih1y">
          Il tuo acquisto è completamente senza rischi. Hai 14 giorni per esplorare tutti i moduli,
          utilizzare sessioni, esercizi, progressioni, programmi, valutazioni e strumenti
          professionali inclusi in PADEL MASTER PRO™. Se per qualsiasi motivo non sarai completamente
          soddisfatto, ti basterà contattarci entro 14 giorni e riceverai il rimborso completo.
        </p>
        <p className="mt-1 text-[12px] font-extrabold text-brand-navy sm:text-sm" data-id="element-77" data-mp="628dt3txepbt">
          Nessun rischio. Nessuna domanda.
        </p>
      </div>
    </section>;
}